<template>
  <ListItem :to="{ name: 'partnerSubType', params: { id: partnerSubType.id } }">
    <div class="grid w-full items-center gap-2 py-1 pl-3 pr-2 text-sm md:grid-cols-[2fr_2fr_1fr]">
      <div>
        <p class="font-bold">{{ getLocalizedField(partnerSubType.name) }}</p>
      </div>

      <div>
        <p>
          {{ partnerSubType.type ? t(`agencyTypes.${partnerSubType.type}`) : t('notSpecified') }}
        </p>
      </div>

      <div class="text-right">
        <span
          class="inline-flex rounded-sm px-2 py-0.5 text-xs font-semibold"
          :class="roleBadgeClass"
        >
          {{ t(`userRoles.${partnerSubType.role}`) }}
        </span>
      </div>
    </div>
  </ListItem>
</template>

<script setup lang="ts">
import { type PartnerSubType } from '@carvia/ros-client-types';
import { useLocalizedFields } from '@/hooks/use-localized-fields';
import ListItem from '@/components/ListItem.vue';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

const { t } = useI18n();
const { getLocalizedField } = useLocalizedFields();

const props = defineProps<{
  partnerSubType: PartnerSubType;
}>();

const roleBadgeClass = computed(() =>
  props.partnerSubType.role === 'AGENCY'
    ? 'bg-blue-50 text-blue-700'
    : 'bg-green-100 text-green-900',
);
</script>

<i18n lang="json">
{
  "en": {
    "notSpecified": "-"
  },
  "de": {
    "notSpecified": "-"
  }
}
</i18n>
